import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toHandlers as _toHandlers, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "x-input-props-form"
};
import { computed, reactive } from 'vue';
import { createFormDesignWidgetConfig } from './config';
export default {
  __name: 'xInputPropForm',
  props: {
    renderOpts: {
      type: Object,
      default: () => ({})
    },
    renderParams: {
      type: Object,
      default: () => ({})
    }
  },
  setup(__props) {
    const {
      options: defaultOptions
    } = createFormDesignWidgetConfig();
    const props = __props;

    // eslint-disable-next-line
    const currWidget = computed(() => {
      const {
        renderParams
      } = props;
      return renderParams.widget || {
        options: {
          ...defaultOptions
        },
        name: '',
        required: false
      };
    });
    const validConfig = reactive({
      theme: 'simple',
      autoPos: true,
      showMessage: true
    });
    const formEvents = {
      submit() {
        console.log('===>> 提交成功');
      },
      reset() {
        console.log('===>> 重置成功');
      }
    };
    return (_ctx, _cache) => {
      const _component_x_input = _resolveComponent("x-input");
      const _component_x_form_item = _resolveComponent("x-form-item");
      const _component_vxe_switch = _resolveComponent("vxe-switch");
      const _component_x_button = _resolveComponent("x-button");
      const _component_x_button_group = _resolveComponent("x-button-group");
      const _component_x_form = _resolveComponent("x-form");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_x_form, _mergeProps({
        vertical: "",
        "title-bold": "",
        "title-overflow": "",
        "valid-config": validConfig,
        data: currWidget.value.options
      }, _toHandlers(formEvents), {
        span: 24
      }), {
        default: _withCtx(() => [_createVNode(_component_x_form_item, {
          span: 24,
          title: "控件名称",
          field: "name"
        }, {
          default: _withCtx(() => [_createVNode(_component_x_input, {
            value: currWidget.value.name,
            "onUpdate:value": _cache[0] || (_cache[0] = $event => currWidget.value.name = $event)
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_x_form_item, {
          span: 8,
          title: "是否必填",
          field: "required"
        }, {
          default: _withCtx(() => [_createVNode(_component_vxe_switch, {
            modelValue: currWidget.value.required,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => currWidget.value.required = $event)
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_x_form_item, {
          span: 8,
          title: "是否只读",
          field: "readonly"
        }, {
          default: _withCtx(() => [_createVNode(_component_vxe_switch, {
            modelValue: currWidget.value.options.readonly,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => currWidget.value.options.readonly = $event)
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_x_form_item, {
          span: 8,
          title: "是否禁用",
          field: "disabled"
        }, {
          default: _withCtx(() => [_createVNode(_component_vxe_switch, {
            modelValue: currWidget.value.options.disabled,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => currWidget.value.options.disabled = $event)
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_x_form_item, {
          span: 24,
          title: "空值占位提示",
          field: "placeholder"
        }, {
          default: _withCtx(() => [_createVNode(_component_x_input, {
            value: currWidget.value.options.placeholder,
            "onUpdate:value": _cache[4] || (_cache[4] = $event => currWidget.value.options.placeholder = $event)
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_x_form_item, {
          span: 24,
          title: "限制字符长度",
          field: "maxLength"
        }, {
          default: _withCtx(() => [_createVNode(_component_x_input, {
            value: currWidget.value.options.maxLength,
            "onUpdate:value": _cache[5] || (_cache[5] = $event => currWidget.value.options.maxLength = $event),
            type: "integer",
            min: "0",
            max: "3000"
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_x_form_item, {
          span: 24,
          title: "是否显示字数统计",
          field: "showWordCount"
        }, {
          default: _withCtx(() => [_createVNode(_component_vxe_switch, {
            modelValue: currWidget.value.options.showWordCount,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => currWidget.value.options.showWordCount = $event)
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_x_form_item, {
          span: 24,
          align: "center"
        }, {
          default: _withCtx(() => [_createVNode(_component_x_button_group, null, {
            default: _withCtx(() => [_createVNode(_component_x_button, {
              type: "submit",
              status: "primary"
            }, {
              default: _withCtx(() => [...(_cache[7] || (_cache[7] = [_createTextVNode("提交", -1)]))]),
              _: 1
            }), _createVNode(_component_x_button, {
              type: "reset"
            }, {
              default: _withCtx(() => [...(_cache[8] || (_cache[8] = [_createTextVNode("重置", -1)]))]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 16, ["valid-config", "data"])]);
    };
  }
};